import * as React from "react";
import BasicNav from "../Nav/BasicNav";
import ReconcilerForm from "../Reconciler/ReconcilerForm";

const TemplatePage: React.FC = () => {
  const [content, setContent] = React.useState<JSX.Element>(
    <ReconcilerForm />
  );
  return (
    <>
      <BasicNav
        content={
          content
        }
        setContent={setContent}
      />
    </>
  );
};
export default TemplatePage;
